// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/vendor.css
// module id = 309
// module chunks = 0